import { createContext } from 'react'

export const OnlineContext = createContext({})
